<app-dialog-banner [text]="data.title" [dialogRef]="dialogRef"></app-dialog-banner>

<div class="body">
    <div class="summary" title="For a quick spot check: 'Units' is an independent count from the current filter criteria, unaffected by how owners get grouped into letters below.">
        <div class="stat">
            <div class="stat-value">{{data.summary.units}}</div>
            <div class="stat-label">Units</div>
        </div>
        <div class="stat">
            <div class="stat-value">{{data.summary.emailContacts}}</div>
            <div class="stat-label">Email</div>
        </div>
        <div class="stat">
            <div class="stat-value">{{data.summary.letterContacts}}</div>
            <div class="stat-label">PDF</div>
        </div>
        <div class="stat stat-total">
            <div class="stat-value">{{data.summary.totalContacts}}</div>
            <div class="stat-label">Total Contacts</div>
        </div>
    </div>

    <div class="table-wrap">
        <table>
            <thead>
                <tr>
                    <th>Channel</th>
                    <th>Full Name</th>
                    <th>Address</th>
                    <th>Unit(s)</th>
                    <th class="num">Outstanding</th>
                    <th>Email</th>
                </tr>
            </thead>
            <tbody>
                @for (r of data.recipients; track $index) {
                    <tr>
                        <td><span class="channel-chip" [class.channel-email]="r.channel === 'email'">{{r.channel}}</span></td>
                        <td>{{r.fullName}}</td>
                        <td [innerHTML]="r.address"></td>
                        <td>{{r.unitName}}</td>
                        <td class="num">{{r.outstanding}}</td>
                        <td>{{r.email}}</td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
</div>
